import { createSlice } from "@reduxjs/toolkit"
import { useCallback, useEffect, useMemo, useState } from "react"
import { shallowEqual, useDispatch, useSelector } from "react-redux"

import { monitoringState, useMonitoredState, forHeartbeat } from "../utils"

const { initialState, actions } = monitoringState()
const reducers = { ...actions }

const slice = createSlice({
  name: 'users',
  initialState, reducers
})

export function useUsers(ids) {
  return useMonitoredState('users', slice.actions, ids)
}

export const heartbeatActions = forHeartbeat(slice.actions)
export default slice.reducer